export class DumpsterListDeactivateDumpstersInput {
  dumpsters: number[];

  constructor(dumpsters: number[]) {
    this.dumpsters = dumpsters;
  }
}
